module.exports = __webpack_public_path__ + "media/我是你的 (电影《我要我们在一起》配乐).0d206932.mp3";